export default __webpack_public_path__ + "images/JJ.5fec12a.png";